module.exports = __WEBPACK_EXTERNAL_MODULE_https_afd_st_olympus_portal_dev_eastus2_002_gvh4fdf0fwfwftfm_a02_azurefd_net_shared_remoteEntry_js_30643039__;